export default __webpack_public_path__ + "static/bgbot-partenaire-b3fe4eff29101d8eb816270489a954d7.jpeg";